<template>
    <!-- Overlay FULLSCREEN -->
    <div class=" " @click.self="close">
      <div
        class=" "
        @dragover.prevent
        @drop.prevent="handleDrop"
      >
        <!-- <h3>Upload Image</h3> -->
  
        <div class="drop-area" @click="openFile">
          Paste (Ctrl+V), Drop Image, atau Klik
        </div>
  
        <p v-if="limit">
          {{ value.length }} / {{ limit }} gambar
        </p>
  
        <input
          ref="file"
          type="file"
          accept="image/*"
          multiple
          hidden
          @change="handleFile"
        />
  
        <!-- <div class="modal-actions">
          <button @click="close">Selesai</button>
        </div> -->
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "UploadModal",
  
    props: {
      value: {
        type: Array,
        default: () => []
      },
      limit: {
        type: Number,
        default: 0
      }
    },
  
    mounted() {
      // PASTE AKTIF HANYA SAAT MODAL ADA
      document.addEventListener("paste", this.handlePaste);
    },
  
    beforeDestroy() {
      document.removeEventListener("paste", this.handlePaste);
    },
  
    methods: {
      close() {
        this.$emit("close");
      },
  
      openFile() {
        this.$refs.file.click();
      },
  
      handlePaste(e) {
        const items = e.clipboardData.items;
        const files = [];
  
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.startsWith("image")) {
            files.push(items[i].getAsFile());
          }
        }
  
        if (files.length) {
          this.process(files);
        }
      },
  
      handleDrop(e) {
        this.process(e.dataTransfer.files);
      },
  
      handleFile(e) {
        this.process(e.target.files);
        e.target.value = "";
      },
  
      process(files) {
        const current = [...this.value];
        const available = this.limit
          ? this.limit - current.length
          : files.length;
  
        if (available <= 0) return;
  
        Array.from(files)
          .filter(f => f.type.startsWith("image"))
          .slice(0, available)
          .forEach(f => current.push(f));
  
        this.$emit("input", current);
        setTimeout(() => {
        this.close()
            
        }, 500);
    }
    }
  };
  </script>
  
  <style scoped>
  /* .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  
  .modal {
    background: white;
    width: 400px;
    max-width: 90%;
    border-radius: 8px;
    padding: 20px;
  } */
  
  .drop-area {
    margin-top: 12px;
    padding: 30px;
    border: 2px dashed #409eff;
    text-align: center;
    border-radius: 6px;
    cursor: pointer;
  }
  
  .modal-actions {
    margin-top: 16px;
    text-align: right;
  }
  
  .modal-actions button {
    padding: 6px 12px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/monitoring/links/imageUpload/uploadModal.vue